import { useState } from 'react';
import axios from 'axios';

import { BROKER_IP } from '../config';

const DEBUG = true


export async function hbl_SearchList(args) {
  if(DEBUG) console.log('hbl_SearchList()', args)

  try {
    let response
    try {
      response = await axios.post(BROKER_IP+'seahousemgt/SearchList', args
    )
    } catch (error) {
      console.log(error)
    }
    
    if(DEBUG) console.log('error 후')
    if(DEBUG) console.log('response', response)
    
    if (response.data.success) {
      const retSearchList = response.data.data.user.rows;
    
      // 데이터가 없으면 처리
      if (retSearchList.length === 0) {
        var retData = {
          "KEY_VALUE_PAIRS" : {
            "TrxMsg" : "Success",
            "TrxCode" : "Y",
            "Status" : "",
          },
          "DataWG1" : {
          }
        }
        return retData;
      }
    
      if(DEBUG) console.log('retSearchList', retSearchList)
    
      // 데이터 형식 변환
      // const retDataList = retSearchList.map((doc) => ({
      //   CHK: doc.CHK,
      //   OFFICE_CD: doc.OFFICE_CD,
      //   BRANCH_CD: doc.BRANCH_CD,
      //   ORD_YMD: doc.ORD_YMD,
      //   RCP_YMD: doc.RCP_YMD,
      //   ORD_MNGT_NO: doc.ORD_MNGT_NO,
      //   ORD_NO: doc.ORD_NO,
      //   QTY: doc.QTY,
      //   TOT_WGT: doc.TOT_WGT,
      //   SKU_QTY: doc.SKU_QTY,
      //   PLT_QTY: doc.PLT_QTY,
      //   WORK_ID: doc.WORK_ID || '',
      //   PLT_NO_STATUS: doc.PLT_NO_STATUS || '',
      // }));

      const retDataList = retSearchList.map((doc, index) => ({
        no: index + 1,
        // HBL 번호
        hbl: doc.HBL_NO || '',
        // ETA BUSAN (YYYYMMDD → YYYY.MM.DD)
        etaBusan: '',
        // 목적지 (DELIVERY or POD)
        destination: doc.DLV_NM || doc.POD_NM || '',
        // 2nd VSL Name
        vslName: doc.VSL || '',
        // TS_HBL_NO
        TS_HBL_NO: doc.TS_HBL_NO || '',
        // VOYAGE
        voyage: doc.VOY || '',
        // PACKAGE (PKG)
        package: doc.PKG || '',
        // WEIGHT / VOLUME
        weightVolume: `${doc.GRS_WGT || 0} / ${doc.MSRMT || 0}`,
        // ETD
        etd: formatDate(doc.ETD),
        // ETA
        eta: formatDate(doc.ETA),
        // N/F
        nf: doc.NFY_CD || '',
        // P/C (선불/후불)
        pc: doc.PRT_OPT1_DESC || '',
      }));

      var retData = {
        "KEY_VALUE_PAIRS" : {
          "TrxMsg" : "Success",
          "TrxCode" : "Y",
          "Status" : "",
        },
        "DataWG1" : {
          retDataList
        },
      }

      return retData
    } else {
      if(DEBUG) console.error('검색 실패:', response.data.message);
      const errMessage = '검색 실패' + response.data.message
      var retData = {
        "KEY_VALUE_PAIRS" : {
          "TrxMsg" : "Fail",
          "TrxCode" : "N",
          "Status" : errMessage,
        },
      }
      return retData;
    }
  } catch (err) {
    if(DEBUG) console.error('서버 오류:', err);
    const errMessage = '서버 오류' + err
    var retData = {
      "KEY_VALUE_PAIRS" : {
        "TrxMsg" : "Fail",
        "TrxCode" : "N",
        "Status" : errMessage,
      },
    }
    return retData;
  }
    
  function formatDate(yyyymmdd) {
    if (!yyyymmdd) return ''
    if (yyyymmdd.length !== 8) return yyyymmdd

    return `${yyyymmdd.slice(0,4)}.${yyyymmdd.slice(4,6)}.${yyyymmdd.slice(6,8)}`
  }

}
